<dx-popup [showTitle]="true" title="Disattiva articolo {{articolo.codice}} {{articolo.descrizione}} {{articolo.taglia}}" [dragEnabled]="false" selectionMode="none" [hideOnOutsideClick]="false"
  [showCloseButton]="true" container=".dx-viewport" visible="true" (onHiding)="onEsciClick()" height="200px" width="600px">
  <div class="row">
    <div class="col-8 col-12 offset-sm-4">
      <dx-button stylingMode="contained" text="CONFERMA" icon="save" type="success" (onClick)="onSalvaClick()" style="width: 150px; margin-right: 10px;">
      </dx-button>
      <dx-button stylingMode="contained" text="ESCI" icon="close" type="danger" (onClick)="onEsciClick()" style="width: 100px;">
      </dx-button>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <b>Sostituisci articolo</b>
      <dx-check-box
        [(value)]="sostituisciConArticolo">
      </dx-check-box>
    </div>
    @if (sostituisciConArticolo) {
      <div class="col-12">
        <dx-lookup
          placeholder="Articolo sostitutivo"
          valueExpr="id"
          [dataSource]="listArticoli"
          [searchEnabled]="true"
          [(value)]="idArticoloSostitutivo"
          [displayExpr]="getArticoloDisplayExpr">
        </dx-lookup>
      </div>
    }
  </div>
</dx-popup>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)"
  [(visible)]="loadPanelVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false">
</dx-load-panel>